import {
  faEdit,
  faFileInvoiceDollar,
  faTrashAlt,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isEmpty } from "lodash";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { useDeepEffect } from "../../../abstracts";
import {
  FeeApplicableToAddedPlansCard,
  FeeApplicableToFilterCard,
  FeeApplicableToPlanInfoCard,
  LoaderWrapper,
  SliderPanel,
} from "../../../components";
import { getPlanListBasedOnFilter } from "../../../services";
import AddPlanButton from "../../Mapper/LoadDefHomeContainer/AddPlanButton";

const FeesApplicableToAddPlan = (props) => {
  const {
    allPlans,
    setAllPlans,
    savePlans,
    setSavePlans,
    setFieldValue,
    errorMsg,
    investmentInformation,
    isEdit,
    isSave,
  } = props;
  const [isModalOpen, setModalOpen] = useState(false);
  const [searchAddedPlans, setSearchAddedPlans] = useState("");
  const [searchPlanList, setSearchPlanList] = useState("");
  const [addedPlans, setAddedPlans] = useState([]);
  const [addedPlansFilter, setAddedPlansFilter] = useState([]);
  const [planListFilter, setPlanListFilter] = useState([]);
  const [plans, setPlans] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [filteredPlans, setFilteredPlans] = useState([]);

  const onViewButtonClick = () => {
    setModalOpen(true);
  };

  useDeepEffect(() => {
    setLoading(true);
    getPlanListBasedOnFilter({
      planType: [],
      statusType: [],
      advisor: [],
      clearingPartner: [],
      planGroup: [],
      investment: investmentInformation?.id,
    })
      .then((response) => {
        setLoading(false);
        setAllPlans(response);
      })
      .catch((error) => setLoading(false));
  }, [investmentInformation]);

  useDeepEffect(() => {
    if (!isEmpty(savePlans)) {
      let plans = [];
      savePlans.map((plan) => {
        allPlans.map((item) => {
          if (item.planId == plan.planId) {
            plans = [
              ...plans,
              {
                ...plan,
                planStatus: item.planStatus,
                rkPlanNumber: item.rkPlanNumber,
                planName: item.planName,
                planType: item.planType,
              },
            ];
          }
        });
      });
      setAddedPlans(plans);
      setAddedPlansFilter(plans);
    }
  }, [savePlans, allPlans]);

  useDeepEffect(() => {
    let temp = [];
    if (!isEmpty(addedPlans)) {
      temp = allPlans.filter(
        (plan) => !addedPlans.map((item) => item.planId).includes(plan.planId)
      );
    } else if (!isEmpty(savePlans)) {
      temp = allPlans.filter(
        (plan) => !savePlans.map((item) => item.planId).includes(plan.planId)
      );
    } else {
      temp = allPlans;
    }
    setPlans(temp);
    setPlanListFilter(temp);
    setFilteredPlans(temp);
  }, [allPlans]);

  const onCancel = () => {
    let temp;
    if (!isEmpty(savePlans)) {
      setAddedPlans(savePlans);
      setAddedPlansFilter(savePlans);
      temp = allPlans.filter(
        (plan) => !savePlans.map((item) => item.planId).includes(plan.planId)
      );
      let plans = [];
      savePlans.map((plan) => {
        allPlans.map((item) => {
          if (item.planId == plan.planId) {
            plans = [
              ...plans,
              {
                ...plan,
                planStatus: item.planStatus,
                rkPlanNumber: item.rkPlanNumber,
                planName: item.planName,
                planType: item.planType,
              },
            ];
          }
        });
      });
      setSavePlans(plans);
    } else {
      temp = allPlans;
      setAddedPlans([]);
      setAddedPlansFilter([]);
    }
    setError("");
    setPlans(temp);
    setPlanListFilter(temp);
    setFilteredPlans(temp);
    setSearchAddedPlans("");
    setSearchPlanList("");
    setModalOpen(false);
  };

  const onSubmit = (plans) => {
    if (isEmpty(plans)) {
      setError("Select a plan to proceed");
    } else {
      let temp = allPlans.filter(
        (plan) => !plans.map((item) => item.planId).includes(plan.planId)
      );
      setFieldValue("allocationMethod", null);
      setError("");
      setSavePlans(plans);
      setAddedPlansFilter(plans);
      setPlanListFilter(temp);
      setFilteredPlans(temp);
      setSearchAddedPlans("");
      setSearchPlanList("");
      setModalOpen(false);
    }
  };

  const onDeleteClick = () => {
    setLoading(true);
    setSavePlans([]);
    setAddedPlans([]);
    setAddedPlansFilter([]);
    getPlanListBasedOnFilter({
      planType: [],
      statusType: [],
      advisor: [],
      clearingPartner: [],
      planGroup: [],
      investment: investmentInformation?.id,
    })
      .then((response) => {
        setLoading(false);
        setPlanListFilter(response);
      })
      .catch((error) => setLoading(false));
  };

  return (
    <div>
      <SliderPanel
        screen="plan-group"
        isOpen={isModalOpen}
        size="80"
        showCancel={false}
      >
        <LoaderWrapper isLoading={loading}>
          <div className="w-100 h-100 planSliderContainer">
            <div className="d-flex justify-content-between">
              <div className="planGroupTitle pr-5 mt-20">
                Add plans Information
              </div>
              <div className="pl-5 mt-20">
                <Button
                  variant="secondary"
                  onClick={() => {
                    onCancel();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    onSubmit(addedPlans);
                  }}
                  className="ml-4"
                >
                  Save
                </Button>
              </div>
            </div>
            <div className="addFeePlansContent">
              <div className="leftcol-fees">
                <FeeApplicableToFilterCard
                  setPlanListFilter={setPlanListFilter}
                  setFilteredPlans={setFilteredPlans}
                  addedPlans={addedPlans}
                  investmentInformation={investmentInformation}
                />
                <FeeApplicableToPlanInfoCard
                  planListFilter={planListFilter}
                  setPlanListFilter={setPlanListFilter}
                  plans={plans}
                  setAddedPlans={setAddedPlans}
                  addedPlans={addedPlans}
                  setAddedPlansFilter={setAddedPlansFilter}
                  setPlans={setPlans}
                  addedPlansFilter={addedPlansFilter}
                  searchAddedPlans={searchAddedPlans}
                  searchPlanList={searchPlanList}
                  setSearchPlanList={setSearchPlanList}
                  filteredPlans={filteredPlans}
                  setFilteredPlans={setFilteredPlans}
                />
              </div>
              <FeeApplicableToAddedPlansCard
                setAddedPlansFilter={setAddedPlansFilter}
                searchAddedPlans={searchAddedPlans}
                addedPlans={addedPlans}
                setSearchAddedPlans={setSearchAddedPlans}
                setPlans={setPlans}
                addedPlansFilter={addedPlansFilter}
                plans={plans}
                setPlanListFilter={setPlanListFilter}
                planListFilter={planListFilter}
                setAddedPlans={setAddedPlans}
                searchPlanList={searchPlanList}
                error={error}
                setFilteredPlans={setFilteredPlans}
              />
            </div>
          </div>
        </LoaderWrapper>
      </SliderPanel>

      {isEmpty(savePlans) ? (
        <>
          <div className="add-module-plan align-items-center justify-content-start bg-white add-items mb-20">
            <div className="p-5">
              <h5 className="mb-3 fee-plan-font">No plans added</h5>
              <AddPlanButton
                className="AddPlan"
                buttonLabel="Add Plans"
                onPrimaryClick={onViewButtonClick}
              />
            </div>
          </div>
          <p className="error-message-deferral">{errorMsg}</p>
        </>
      ) : (
        <div className="addedPlan-Card mb-20">
          <div className="addedPlans-card-font"> Plans added</div>
          <div className="d-flex">
            <div className="mt-20">
              <FontAwesomeIcon icon={faFileInvoiceDollar} />
            </div>
            <div className="addedPlans-card-font1 ml-2 mt-15">
              {savePlans.length}
            </div>
            <div
              style={{ cursor: isEdit ? "not-allowed" : "default" }}
              className="edit-color pl-10"
              onClick={() => {
                !isEdit && setModalOpen(true);
              }}
            >
              <FontAwesomeIcon icon={faEdit} />
            </div>
            <div
              style={{ cursor: isEdit ? "not-allowed" : "default" }}
              className="trash-color pl-3"
              onClick={() => {
                !isEdit && onDeleteClick();
              }}
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeesApplicableToAddPlan;
